module.exports = __webpack_public_path__ + "static/media/04.chrome.97875363.svg";